export class ClassementFardeChemise {
  id: number;
  code: string;
  description: string;
  actif: boolean;
  parentId: number;
}
